// extracted by mini-css-extract-plugin
export var cardHeader = "_jr-1";
export var contentCard = "_jr-0";
export var headerActions = "_jr-3";
export var reorderHandle = "_jr-5";
export var titleArea = "_jr-2";
export var titleAreaWithHandle = "_jr-4";